import http from "../http-common";

class FlightTypeService {
  getFlightTypeDescription(token) {
    return http.get<any[]>("/FlightTypeInfo",{
        headers: {
            Authorization: `Bearer ${token}`
    }
    });
  }
}

const flightTypeService = new FlightTypeService();
export default flightTypeService;
